export default __webpack_public_path__ + "25a2c645bfdd2d390b7c674a1a7b18a6.svg";